<template>
  <div class="container-fluid p-0 position-relative">
    <div class="w-100 news-main-carousel-v2">
      <div class="owl-carousel owl-theme" id="mastheadcar">
        <div
          class="item"
          v-for="(item_featured, idx) in news_masthead_featured"
          :key="item_featured.id"
        >
          <div
            class="item_img cursor-pointer"
            @click="goTo(getAssetLink(item_featured))"
          >
            <img
              v-bind:src="item_featured.img_link"
              @error="imageLoadError($event)"
            />
            <div class="overlay"></div>
          </div>
          <div class="details_box">
            <div class="w-100 position-relative">
              <div class="details-wrapper mb-3">
                <!-- popularity -->
                <div class="w-100 d-flex justify-content-start">
                  <div class="list-wrapper">
                    <span>TOP {{ idx + 1 }}</span>
                  </div>
                </div>
                <!-- description -->
                <div class="w-100 mt-2 pr-2">
                  <p
                    class="main-title"
                    v-if="
                      item_featured.data.title ||
                        item_featured.data.banner.title
                    "
                    :title="
                      item_featured.idSchema == 2014
                        ? item_featured.data.banner.title
                        : item_featured.data.title
                    "
                  >
                    <!-- <Trunquee :text="item_featured.data.title" :speed="120" /> -->
                    {{
                      truncateString(
                        item_featured.idSchema == 2014
                          ? item_featured.data.banner.title
                          : item_featured.data.title,
                        60
                      )
                    }}
                  </p>
                  <p
                    class="desc"
                    v-if="
                      item_featured.data.description ||
                        (item_featured.data.banner &&
                          item_featured.data.banner.caption)
                    "
                  >
                    {{
                      truncateString(
                        item_featured.idSchema == 2014
                          ? item_featured.data.banner.caption
                          : item_featured.data.description,
                        200
                      )
                    }}
                  </p>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div
                  class="buttonWrapper mr-2"
                  @click="goTo(getAssetLink(item_featured))"
                >
                  <div class="icon">
                    <img
                      src="../../../assets/rtmklik/main-play.svg"
                      alt="play icon"
                    />
                  </div>
                  <p class="d-none d-lg-block mb-0 label ml-2">
                    Tonton Sekarang
                  </p>
                </div>
                <!-- <div class="buttonWrapper mr-2">
                  <div class="icon">
                    <img
                      src="../../../assets/rtmklik/main-like.svg"
                      alt="play icon"
                    />
                  </div>
                  <p class="d-none d-lg-block mb-0 label ml-2">Kegemaran</p>
                </div>
                <div class="buttonWrapper mr-2">
                  <div class="icon">
                    <img
                      src="../../../assets/rtmklik/main-share.svg"
                      alt="play icon"
                    />
                  </div>
                  <p class="d-none d-lg-block mb-0 label ml-2">Kongsi</p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="owl-theme">
        <div class="owl-controls d-md-block d-none">
          <div class="custom-nav owl-nav"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import ChevronRight from "../../../assets/rtmklik/chevron-right.svg";
import ChevronLeft from "../../../assets/rtmklik/chevron-left.svg";
import axios from "axios";

export default {
  data: function() {
    return {
      news_masthead_featured: [],
      external_link: "/live/tv2",
      mobile: false,
      desktop: false,
      customBanner: [],
    };
  },
  created: function() {
    this.$store.dispatch("fetchNewsMastheadsFeatured", { self: this });
  },
  methods: {
    async getCustomFeaturedBanner() {
      const img_domain = `https://rtm-images.glueapi.io`;
      const img_size = "960x0";

      let response = await axios.get(
        "https://rtm.glueapi.io/v3/content?idSchema=2014&&fieldPath=position&fieldValue=771",
        {
          responseType: "json",
        }
      );
      // console.log(items.data.banner);

      let items = response.data.data;
      if (items) {
        items.forEach((element) => {
          const banner_link = `${img_domain}/${img_size}/${
            element.data.banner.path
          }`;
          element["img_link"] = banner_link;
          element["redirect_link"] = element.data.banner.link;
        });
      }

      //console.log("customBanner", JSON.stringify(response.data.data, null, 2));

      return items;
    },
    async filterNewsMastheadFeatured() {
      var vm = this;
      var store = []; // enable this when komanwel is over

      vm.news_masthead_featured = vm.$store.state.news_masthead_featured.data;
      // let customBanner = await this.getCustomFeaturedBanner();

      // if (customBanner.length > 0) {
      //   customBanner.forEach((element) => {
      //     store.push(element);
      //   });
      // }
      vm.news_masthead_featured.forEach((item) => {
        item["img_link"] = vm.rtmImgLinkFiltering(item.data.images, "960x0");
        store.push(item);
      });

      vm.news_masthead_featured = store;
      Vue.nextTick(
        function() {
          vm.installOwlCarouselForMasthead("#mastheadcar");
        }.bind(vm)
      );
    },
    goTo(link) {
      this.$router.push(link);
    },
    goToExternal(link) {
      window.open(link, "_blank").focus();
      // this.$router.push(link);
    },
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },

    installOwlCarouselForMasthead: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        lazyLoad: true,
        loop: false,
        nav: false,
        center: true,
        navText: [
          `<div class="border-nav"><img src=${ChevronLeft} /></div>`,
          `<div class="border-nav"><img src=${ChevronRight} /></div>`,
        ],
        navContainer: ".news-main-carousel-v2 .custom-nav",
        dots: true,
        margin: 0,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: true,
          },
          768: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: false,
          },
          990: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: true,
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.item {
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 80px;
}
.item .item_img {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-top: 67.6%;
}
.item .item_img img {
  background: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
  top: 48%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 76%;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 26.23%,
    rgba(0, 0, 0, 0.8) 66.65%,
    #000 100%
  );
  z-index: 2;
}

.item-details {
  position: absolute;
  bottom: 24%;
  left: 8%;
  max-width: 600px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  z-index: 3;
}

.btn-wrapper {
  width: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.play-btn-wrapper {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #dae12f;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}
.play-btn-wrapper img {
  margin-left: 6px;
  width: 100% !important;
}
.bookmark-btn-wrapper {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}
.bookmark-btn-wrapper img {
  width: 100% !important;
  margin-left: 4px;
}

.list-wrapper {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: #dae12f;
  border-radius: 8px;
}
.list-wrapper span {
  color: #000;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.popularity-wrapper,
.category-wrapper {
  width: auto;
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: #373946;
}
.popularity-wrapper span,
.category-wrapper span {
  font-family: "HelveticaNeue-Bold";
  font-size: 12px;
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
}
.main-title {
  color: #fff;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.desc {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  text-align: left;
}
.buttonWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.buttonWrapper .icon {
  width: 40px;
  height: 40px;
}
.buttonWrapper .icon img {
  width: 100%;
  height: 100%;
}
.buttonWrapper .label {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.details_box {
  position: absolute;
  bottom: 6%;
  z-index: 11;
  padding: 16px;
  display: flex;
  justify-content: center;
  max-width: 100%;
}
.details-wrapper {
  min-height: 84px;
}
@media only screen and (min-width: 992px) {
  .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 76%;
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 43.23%,
      rgba(0, 0, 0, 0.8) 78.65%,
      #000 100%
    );
    z-index: 2;
  }
  .item {
    margin-bottom: 0px;
  }
  .item .item_img {
    width: 100%;
    overflow: hidden;
    position: relative;
    padding-top: 59.14%;
  }
  .details_box {
    position: absolute;
    bottom: 23%;
    left: 40px;
    width: 100%;
    max-width: 676px;
    min-height: 268px;
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.5);
    padding: 24px;
    z-index: 4;
  }
  .details-wrapper {
    min-height: 120px;
  }
}
@media only screen and (min-width: 1600px) {
  .details_box {
    max-width: 820px;
  }
}

@media only screen and (max-width: 768px) {
  .item {
    margin-bottom: 60px;
  }
  .item .item_img {
    padding-top: 84%;
  }
}
@media only screen and (max-width: 576px) {
  .item {
    margin-bottom: 40px;
  }
  .item .item_img {
    padding-top: 126.6%;
  }
}
</style>
<style>
.news-main-carousel-v2 .owl-theme .owl-dots {
  bottom: 12%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.news-main-carousel-v2 .owl-theme .owl-dots .owl-dot span {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  border-radius: 50%;
  background-color: #d9d9d9;
}

.news-main-carousel-v2 .owl-theme .owl-dots .owl-dot.active span,
.news-main-carousel-v2 .owl-theme .owl-dots .owl-dot:hover span {
  background: #dae12f;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin: 0 4px;
}

.news-main-carousel-v2 .owl-theme .custom-nav {
  width: 80px;
  position: absolute;
  bottom: 160px;
  right: 16px;
  left: unset;
  z-index: 5;
}

@media only screen and (max-width: 768px) {
  .news-main-carousel-v2 .owl-theme .owl-dots {
    bottom: 8%;
  }
  .news-main-carousel-v2 .owl-theme .custom-nav {
    bottom: 140px;
  }
}
@media only screen and (max-width: 576px) {
  .news-main-carousel-v2 .owl-theme .owl-dots {
    bottom: 6%;
  }
  .news-main-carousel-v2 .owl-theme .custom-nav {
    bottom: 112px;
  }
}

.news-main-carousel-v2 .owl-theme .custom-nav .owl-prev,
.news-main-carousel-v2 .owl-theme .custom-nav .owl-next {
  position: absolute;
  color: inherit;
  background: rgba(0, 0, 0, 0);
  border: none;
  z-index: 100;
  top: 50%;
  transform: translateY(-50%);
  border-radius: none;
  width: 24px;
  outline: none;
}
.news-main-carousel-v2 .owl-theme .custom-nav .owl-prev .border-nav,
.news-main-carousel-v2 .owl-theme .custom-nav .owl-next .border-nav {
  width: 24px;
  height: 24px;
}
.news-main-carousel-v2 .owl-theme .custom-nav .owl-prev .border-nav i,
.news-main-carousel-v2 .owl-theme .custom-nav .owl-next .border-nav i {
  font-size: 2.4rem;
  color: #dae12f;
  padding: 0 10px;
}
.news-main-carousel-v2 .owl-theme .custom-nav .owl-prev {
  left: 0;
  display: flex;
  justify-content: center;
}
.news-main-carousel-v2 .owl-theme .custom-nav .owl-next {
  right: 0;
  display: flex;
  justify-content: center;
}
.news-main-carousel-v2 .owl-theme .owl-nav [class*="owl-"]:hover {
  background: unset !important;
}
.news-main-carousel-v2
  .owl-theme
  .owl-stage-outer
  .owl-stage
  .owl-item:not(.center)
  > div {
  opacity: 0.25;
  z-index: 5;
}

@media only screen and (min-width: 992px) {
  .news-main-carousel-v2 .owl-theme .owl-dots {
    position: absolute;
    bottom: 25%;
    left: 154px;
    transform: translateX(-50%);
  }

  .news-main-carousel-v2 .owl-theme .custom-nav {
    width: 80px;
    position: absolute;
    bottom: 27%;
    left: 264px;
    right: unset;
    z-index: 5;
  }
}
</style>
